import { Link } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';

/* BhcLogo — official KGOB lockup SVG. `light` selects the white-letter variant for dark backgrounds (footer). */
export const BhcLogo = ({ light = false, to = '/business-health-check', style }) => (
  <Link
    to={to}
    className="logo"
    aria-label="KGOB — Kohari Gonzalez Oneyear & Brown, home"
    style={style}
    data-testid="bhc-logo"
  >
    <img
      className="logo__lockup"
      src={light ? '/brand/kgob-logo-dark.svg' : '/brand/kgob-logo-light.svg'}
      alt="Kohari Gonzalez Oneyear & Brown CPAs & Advisors"
    />
  </Link>
);

/**
 * BhcHeader — marketing header for the Health Check funnel (distinct from the
 * main site Header). `nav` is an array of { label, href } (href = in-page hash
 * or a path). `cta` is the primary button { label, to }.
 */
export const BhcHeader = ({ nav = [], cta }) => (
  <header className="site-header" data-testid="bhc-site-header">
    <div className="wrap site-header__bar">
      <BhcLogo />
      <nav className="site-header__nav" aria-label="Primary">
        {nav.map((item) =>
          item.to ? (
            <Link data-testid="bhc-header-link-1" key={item.label} to={item.to}>{item.label}</Link>
          ) : (
            <a data-testid="bhc-header-a-1" key={item.label} href={item.href}>{item.label}</a>
          )
        )}
      </nav>
      <div className="site-header__actions">
        {/* Existing Health Check clients — passwordless sign-in to manage their reservation.
            Scoped to THIS funnel only (separate from the main-site / Ask-a-CPA logins). */}
        <Link
          to="/business-health-check/manage"
          className="site-header__login"
          data-testid="bhc-header-login"
          aria-label="Manage my booking — existing Health Check client sign in"
          title="Already booked your Health Check? Sign in to view or reschedule your intake call."
        >
          <CalendarCheck size={16} aria-hidden="true" />
          <span>Manage My Booking</span>
        </Link>
        {cta && (
          <Link className="btn btn--primary" to={cta.to} data-testid="bhc-header-cta">
            {cta.label} <span className="arrow">→</span>
          </Link>
        )}
      </div>
    </div>
  </header>
);
